import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';

const NotificationIcon = (props) => (
  <SvgIcon {...props}>
    <circle fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" cx="16" cy="7.5" r="4"/>
    <polyline fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" points="
      9,8 4,8 4,20 16,20 16,15 "/>
  </SvgIcon>
);

export default NotificationIcon;



// WEBPACK FOOTER //
// ./src/icons/menu/NotificationIcon.jsx